const API_URL = "https://thenoid.onrender.com/api";
 
/**
 * Initiate checkout — returns a Flutterwave hosted payment link
 */
export const initiateCheckout = async (formData) => {
  const response = await fetch(`${API_URL}/checkout`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(formData),
  });
 
  const data = await response.json();
 
  if (!response.ok || !data.success) {
    throw new Error(data.message || "Failed to create payment");
  }
 
  return data;
};
 
/**
 * Verify payment after redirect from Flutterwave
 */
export const verifyPayment = async ({ tx_ref, transaction_id, status }) => {
  const params = new URLSearchParams({ tx_ref, transaction_id, status });
  const response = await fetch(`${API_URL}/payment/verify?${params}`);
  const data = await response.json();
  return data;
};